import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchRVMTemplate,
  deleteRVMTemplate,
  updateRVMTemplate,
  createTestRVM
} from "../actions/index";
import { Link } from "react-router-dom";
import RVMTemplatesForm from "./RVMTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';

class RVMTemplatesEdit extends Component {
  static propTypes = {
    fetchRVMTemplate: PropTypes.func.isRequired,
    deleteRVMTemplate: PropTypes.func.isRequired,
    updateRVMTemplate: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    rvmTemplate: PropTypes.object,
    createTestRVM: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchRVMTemplate(
      this.props.match.params.id
    );
  }

  sendTestRVM(state) {
    this.props
      .createTestRVM(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test voicemail queued to send");
        }
      });
  }

  onDeleteClick() {
    this.props
      .deleteRVMTemplate(this.props.match.params.id)
      .then(response => {
        if (response.payload.status == "200") {
          toastr.success("Voicemail Template deleted!");
          this.props.history.push(`/rvm_templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  onSubmit(state) {
    this.props
      .updateRVMTemplate(
        this.props.match.params.id,
        state
      )
      .then(response => {
        if (response.payload.status == "200") {
          toastr.success("Voicemail Template saved!");
          this.props
            .fetchRVMTemplate(
              this.props.match.params.id
            )
            .then(() => {
              this.props.history.push(`/rvm_templates?${Constants.DEFAULT_PAGINATION}`);
            });
        }
      });
  }

  campaignsUsing() {
    if (this.props.rvmTemplate.data.campaigns_using.length == 0) {
      return <div />;
    }
    let campaigns_using = this.props.rvmTemplate.data.campaigns_using.map(
      campaign => {
        return (
          <tr key={campaign.id}>
            <td>
              <Link
                to={`/campaigns/${campaign.id}`}
              >
                {campaign.name}
              </Link>
            </td>
            <td className="text-right">
              <Link
                to={`/campaigns/${campaign.id}`}
                className="btn btn-sm btn-primary template_edit"
              >
                Edit
              </Link>
            </td>
          </tr>
        );
      }
    );
    return (
      <div className="m-t-20 clearfix">
        <h4>Workflows using this template</h4>
        <table className="table table-striped">
          <tbody>{campaigns_using}</tbody>
        </table>
      </div>
    );
  }

  render() {
    const { rvmTemplate } = this.props;
    if (!rvmTemplate) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }

    return (
      <div>
        <h1>Edit Ringless Voicemail</h1>
        <RVMTemplatesForm
          key={rvmTemplate.data.id}
          match={this.props.match}
          handleSubmit={this.onSubmit.bind(this)}
          handleDelete={this.onDeleteClick.bind(this)}
          mode="edit"
          name={rvmTemplate.data.name}
          categories={rvmTemplate.data.categories}
          handleSendTestRVM={this.sendTestRVM.bind(this)}
          rvm_template_category_id={rvmTemplate.data.rvm_template_category_id}
          s3_url={rvmTemplate.data.s3_url}
        />
        {this.campaignsUsing()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { rvmTemplate: state.rvmTemplates.rvmTemplate };
}

export default connect(
  mapStateToProps,
  {
    fetchRVMTemplate,
    updateRVMTemplate,
    deleteRVMTemplate,
    createTestRVM
  }
)(RVMTemplatesEdit);
